module.exports = __webpack_public_path__ + "media/images/landing/solutions/solution-2-31762adbff2def4a5bc732d873d5f40e.png";